import React, { useCallback, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import baseUrl from "../../../../../api/baseUrl";
import { usePrintSettings } from "../PrintSettingsContext";

function Logo({ item, src, centered }: any) {
  const dispatch = useDispatch();
  const { printAction, grabApi } = usePrintSettings();
  const [cursor, setcursor] = useState("grab");
  const dragStart = useRef<{ clientX: number; clientY: number; left: number; top: number } | null>(
    null
  );

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (dragStart.current == null || item?.title == null) return;
      const { clientX, clientY, left, top } = dragStart.current;
      const newTop = top + (e.clientY - clientY);
      const newLeft = left + (e.clientX - clientX);
      dispatch(printAction({ name: item.title, target: "top", value: newTop }));
      dispatch(printAction({ name: item.title, target: "left", value: newLeft }));
      baseUrl.patch(grabApi, {
        name: item.title,
        left: newLeft,
        top: newTop,
      });
    },
    [dispatch, grabApi, item?.title, printAction]
  );

  const handleMouseUp = useCallback(() => {
    dragStart.current = null;
    setcursor("grab");
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  }, [handleMouseMove]);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    if (item?.title == null) return;
    setcursor("grabbing");
    dragStart.current = {
      clientX: e.clientX,
      clientY: e.clientY,
      left: Number(item?.left) || 0,
      top: Number(item?.top) || 0,
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const horizontalOffset = Number(item?.left) || 0;
  const size = item?.size ?? 36;

  return (
    <img
      style={{
        position: "absolute",
        top: item?.top,
        left: centered ? "50%" : item?.left,
        height: size,
        width: size,
        display: item?.show ? "" : "none",
        transform: centered
          ? `translate(calc(-50% + ${horizontalOffset}px), 0)`
          : undefined,
        objectFit: "contain",
      }}
      crossOrigin="anonymous"
      src={src}
      alt=""
      className={centered ? cursor : undefined}
      onMouseDown={centered ? handleMouseDown : undefined}
    />
  );
}

export default Logo;
